export class CategoricalStrategy {
    constructor() {
        this.name = "CategoricalStrategy";
        this.has_legend = true;
        this.is_gradient = false;
    }
    visible_inputs() {
        let inputs = [
            'colorize-field',
            'colorize-numcolors',
            'colorize-gradient',
            'colorize-strategy',
            'colorize-opacity'
        ];
        return inputs;
    }
    generate_colors(color_range) {
        const choices = this.colors();
        let colors = [];
        for (let i = 0; i < color_range.steps; i++) {
            colors.push(choices[i % choices.length]);
        }
        color_range.update_jenks(colors);
        return colors;
    }
}
